import authorizedRequest from 'api/request/authorizedRequest';
import { PREFIX_API } from 'constants/api.const';
import { preprocessGetQuery } from 'helpers/api.helper';
import { getFormData } from 'helpers/form-data.helper';
import {
  ActiveMessageTemplateRequestModel,
  ActiveMessageTemplateResponseModel,
  DeleteMessageTemplateRequestModel,
  DeleteMessageTemplateResponseModel,
  GetMessageTemplateRequestModel,
  GetMessageTemplateResponseModel,
  InactiveMessageTemplateRequestModel,
  InactiveMessageTemplateResponseModel,
  ListMessageTemplateRequestModel,
  ListMessageTemplateResponseModel,
  SaveMessageTemplateRequestModel,
  SaveMessageTemplateResponseModel,
  SendMessageTemplateToMemberRequestModel,
  SendMessageTemplateToMemberResponseModel,
} from 'models/setting/message-template/message-template.model';

export function getMessageTemplate(payload: GetMessageTemplateRequestModel) {
  if (payload?.id) {
    return authorizedRequest.get<
      GetMessageTemplateResponseModel,
      GetMessageTemplateResponseModel
    >(`${PREFIX_API.GENERAL}/message-templates/${payload?.id}`);
  }
}

export function listMessageTemplate(payload: ListMessageTemplateRequestModel) {
  return authorizedRequest.get<
    ListMessageTemplateResponseModel,
    ListMessageTemplateResponseModel
  >(`${PREFIX_API.GENERAL}/message-templates?${preprocessGetQuery(payload)}`);
}

export function createMessageTemplate(
  payload: SaveMessageTemplateRequestModel,
) {
  const formDataPayload = getFormData(payload);

  return authorizedRequest.post<
    SaveMessageTemplateResponseModel,
    SaveMessageTemplateResponseModel
  >(`${PREFIX_API.GENERAL}/message-templates`, formDataPayload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function updateMessageTemplate(
  payload: SaveMessageTemplateRequestModel,
) {
  const formDataPayload = getFormData(payload);

  if (payload?.id) {
    return authorizedRequest.put<
      SaveMessageTemplateResponseModel,
      SaveMessageTemplateResponseModel
    >(
      `${PREFIX_API.GENERAL}/message-templates/${payload?.id}`,
      formDataPayload,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    );
  }
}

export function deleteMessageTemplate(
  payload: DeleteMessageTemplateRequestModel,
) {
  return authorizedRequest.delete<
    DeleteMessageTemplateResponseModel,
    DeleteMessageTemplateResponseModel
  >(`${PREFIX_API.GENERAL}/message-templates/${payload?.id}`);
}

export function inactiveMessageTemplate(
  payload: InactiveMessageTemplateRequestModel,
) {
  return authorizedRequest.put<
    InactiveMessageTemplateResponseModel,
    InactiveMessageTemplateResponseModel
  >(`${PREFIX_API.GENERAL}/message-templates/${payload?.id}/inactive`);
}

export function activeMessageTemplate(
  payload: ActiveMessageTemplateRequestModel,
) {
  return authorizedRequest.put<
    ActiveMessageTemplateResponseModel,
    ActiveMessageTemplateResponseModel
  >(`${PREFIX_API.GENERAL}/message-templates/${payload?.id}/active`);
}

export function sendMessageTemplateToMember(
  payload: SendMessageTemplateToMemberRequestModel,
) {
  return authorizedRequest.post<
    SendMessageTemplateToMemberResponseModel,
    SendMessageTemplateToMemberResponseModel
  >(
    `${PREFIX_API.GENERAL}/message-templates/send-message?${preprocessGetQuery(
      payload,
    )}`,
  );
}
